import { Component, ElementRef, HostListener } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[placeme-repple]',
  templateUrl: './repple.component.html',
  styleUrls: ['./repple.component.scss'],
})
export class ReppleComponent {
  constructor(private _elementRef: ElementRef<HTMLElement>) {}

  @HostListener('mousedown', ['$event'])
  onClick($event: any): void {
    const x: number = $event.layerX;
    const y: number = $event.layerY;

    const repple: HTMLSpanElement = document.createElement('span');
    repple.classList.add('repple');
    repple.setAttribute('style', `top: ${y}px;left: ${x}px;`);
    this._elementRef.nativeElement.appendChild(repple);
    setTimeout(() => {
      this._elementRef.nativeElement.removeChild(repple);
    }, 900);
  }
}
